<div class="dq-panel">
  <div class="dq-header">
    <div class="dq-header-left">
      <span class="dq-dot"></span>
      <span class="dq-title">{{settings?.Title || 'Data quality'}}</span>
    </div>
    @if (badgeText) {
      <span class="dq-badge">{{badgeText}}</span>
    }
  </div>

  <div class="dq-items">
    @for (item of items; track item) {
      <div class="dq-item">
        <div class="dq-item-header">
          <span class="dq-item-label">{{item.Label}}</span>
          <span class="dq-item-pct">{{item.Percentage}}%</span>
        </div>
        <div class="dq-bar-track">
          <div class="dq-bar-fill" [style.width.%]="item.Percentage" [style.background]="item.Color"></div>
        </div>
      </div>
    }
  </div>

  @if (recommendation.Text) {
    <div class="dq-recommendation">
      <span class="dq-rec-icon">💡</span>
      <span class="dq-rec-text">
        @if (recommendationLabel) {
          <strong>{{recommendationLabel}}:</strong>
        }
        {{recommendation.Text}}
        @if (recommendation.LinkText) {
          <a class="dq-rec-link" (click)="navigate(recommendation.Url)">{{recommendation.LinkText}}</a>
        }
      </span>
    </div>
  }
</div>
